export const privateOptions: {name: string, value: boolean}[] = [
  {name: 'private-options.privates', value: true},
  {name: 'private-options.companies', value: false},
];